import React from 'react';
// utils
import * as yup from 'yup';
// redux
import { compose } from 'redux';
import { connect } from 'react-redux';
import { addNote } from '../../../redux/reducers/journals';
// utils
import { withFormik } from 'formik';
import { responseErrors } from '../../../utils/response';
// components
import FormErrors from '../../../components/Form/FormErrors';
import Input from '../../../components/Input/Input';
import TextArea from '../../../components/TextArea/TextArea';
import Button from '../../../components/Button/Button';
import FieldError from '../../../components/Form/FieldError';
import Form from '../../../components/Form/Form';
// styles
import styles from './AddNewNote.mod.css';

const AddNewNote = ({
  values,
  touched,
  errors = {},
  isSubmitting,
  handleBlur,
  handleChange,
  handleSubmit,
  closeModal,
  modalData: { userColor }
}) => (
  <Form className={styles.wrapper} onSubmit={handleSubmit}>
    <h2 className={styles.title}>Adding new note</h2>
    <FormErrors errors={errors} />
    <div className={styles.formControl}>
      <label className={styles.label} htmlFor="title">
        Title
      </label>
      <div>
        <Input
          color={userColor}
          name="title"
          placeholder="Type a title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.title && touched.title}
        />
        <FieldError error={errors.title} touched={touched.title} />
      </div>
    </div>

    <div className={styles.formControl}>
      <label className={styles.label} htmlFor="content">
        Note
      </label>
      <div>
        <TextArea
          rows="6"
          color={userColor}
          className={styles.textArea}
          name="content"
          placeholder="Type a note"
          value={values.content}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.content && touched.content}
        />
        <FieldError error={errors.content} touched={touched.content} />
      </div>
    </div>

    <div className={styles.buttonSection}>
      <Button plain onClick={closeModal} disabled={isSubmitting}>
        Cancel
      </Button>
      <Button
        type="submit"
        color={userColor}
        isLoading={isSubmitting}
        disabled={isSubmitting}
      >
        Add note
      </Button>
    </div>
  </Form>
);

const enhance = compose(
  connect(
    null,
    { addNote }
  ),
  withFormik({
    mapPropsToValues: () => ({
      content: '',
      title: ''
    }),
    validationSchema: yup.object().shape({
      title: yup
        .string()
        .min(4, 'Title must be longer')
        .required('Title is required!'),
      content: yup
        .string()
        .min(4, 'Note must be longer')
        .required('Note is required!')
    }),
    handleSubmit: (
      values,
      { setSubmitting, setErrors, props: { closeModal, addNote } }
    ) => {
      addNote({
        data: values
      })
        .then(() => {
          setSubmitting(false);
          closeModal();
        })
        .catch(response => {
          setErrors(responseErrors(response));
          setSubmitting(false);
        });
    },
    displayName: 'AddNewNoteForm'
  })
);

export default enhance(AddNewNote);



// WEBPACK FOOTER //
// ./src/containers/Journal/components/AddNewNote.jsx